import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router';
import { useStore } from '../store';
import { applyUpdate, onUpdateReady } from '../lib/sw';
import { cls } from '../lib/util';

export function Toasts() {
  const { toasts, dismiss } = useStore();
  const loc = useLocation();
  const [update, setUpdate] = useState(false);
  const [later, setLater] = useState(false);
  useEffect(() => onUpdateReady(setUpdate), []);
  const showUpdate = update && !later && !loc.pathname.startsWith('/battle/'); // never interrupt a battle
  if (!toasts.length && !showUpdate) return null;
  return (
    <div className="toasts" role="status" aria-live="polite">
      {showUpdate && <div className="toast success"><span>Update available</span><button className="btn xs" onClick={applyUpdate}>Reload</button><button className="x" aria-label="Later" onClick={() => setLater(true)}>×</button></div>}
      {toasts.map((t) => (
        <div key={t.id} className={cls('toast', t.kind)}>
          {t.href ? <Link to={t.href} onClick={() => dismiss(t.id)}>{t.text}</Link> : <span>{t.text}</span>}
          {t.action && <button className="btn xs" onClick={() => { t.action!.onClick(); dismiss(t.id); }}>{t.action.label}</button>}
          <button className="x" aria-label="Dismiss" onClick={() => dismiss(t.id)}>×</button>
        </div>
      ))}
    </div>
  );
}
